





































































import { Component, Vue } from "vue-property-decorator";
import { usersService } from "@/services";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Multiselect from "vue-multiselect";
// import { UsersModel } from "@/models";
import { EventBus } from "@/main.ts";
import { extend } from "vee-validate";
// import { email } from "vee-validate/dist/rules";
import Modal from "../modal/modal.vue";
import AddUser from './adduser.vue';
extend("required", {
  message: "Required Field",
  validate(value: string) {
    return {
      required: true,
      valid: ["", null, undefined].indexOf(value) === -1,
    };
  },
  computesRequired: true,
});
@Component({
  name: "app-component",
  components: {
    Multiselect,
    ValidationProvider,
    ValidationObserver,
    Modal,
    AddUser

  },
})
export default class Users extends Vue {
  public res: any = [];
  public value = [];
  public options: any[] = [];
  private customerSerialIDs: any[] = [];
  private addUserModal = false;
  mounted() {
    // this.getAllUsers();
    EventBus.$on("close-modal", (event: boolean) => {
      // alert(event)
      if (event == false) {
        this.addUserModal = false;
      }
    });
  }

  getAllUsers() {
    usersService.getAllUsers().then((x: any) => {
      this.options = x.data.users_id;
    });
  }

  close() {
    this.addUserModal = false;
  }

  // addCustomer() {
  //   this.value.forEach((x: any) => {
  //     this.customerSerialIDs.push(x.serial_id);
  //   });
  //   customerService.addCustomer(customer).then((response: any) => {
  //     if (response.meta.status_code == 200) {
  //       this.$toasted.global.throw({
  //         message: "Customer added successfully",
  //       });
  //     } else {
  //       this.$toasted.global.throw({
  //         message: "Something went wrong",
  //       });
  //     }
  //   });
  //   // alert(JSON.stringify(customer));
  //   EventBus.$emit("close-modal", false);
  // }
}
